import { Dialog, DialogContent, DialogTitle, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import StripePaymentComponent from "src/components/stripe/stripe-payment.component";

const PaymentDialogComponent = ({ clientSecret, amount,planName, handleClose, currencySymbol }) => {
    const { t: translate } = useTranslation();
    return (
        <Dialog onClose={() => { handleClose(false) }} open>
            <DialogTitle>
                <Stack direction="row" justifyContent="space-between" alignItems="center">
                    <Typography variant="h6" fontWeight="bold">{translate("billing.subscription_info.payment")}</Typography>
                </Stack> </DialogTitle>
            <DialogContent dividers>
                <StripePaymentComponent clientSecret={clientSecret} planName={planName} currencySymbol={currencySymbol} amount={amount} />
            </DialogContent>
        </Dialog>
    );
}
export default PaymentDialogComponent;